import { useQuery } from '@tanstack/react-query';

type AppInfo = {
  version: string;
};

export const useAppInfo = () => {
  const { data, isLoading, isError, error, refetch } = useQuery<AppInfo>({
    queryKey: ['info'],
  });

  return {
    info: data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
